"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _globals = require("@insided/shared/utils/globals");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _categoryGroup = _interopRequireDefault(require("./category-group"));

var _list = _interopRequireDefault(require("./list"));

var _link = _interopRequireDefault(require("./link"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _index = _interopRequireDefault(require("@insided/shared/uikit/dropdown/index"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'main-menu';
exports.cssAnchorName = cssAnchorName;

var MainMenu = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(MainMenu, _Component);

  var _super = _createSuper(MainMenu);

  function MainMenu() {
    (0, _classCallCheck2.default)(this, MainMenu);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(MainMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          communityCategories = _this$props.communityCategories,
          knowledgeBaseCategories = _this$props.knowledgeBaseCategories,
          showActivitySinceLastVisit = _this$props.showActivitySinceLastVisit;
      return (0, _preact.h)("div", {
        className: "main-menu"
      }, (0, _preact.h)(_index.default, {
        class: "dropdown dropdown--forums-overview",
        trigger: (0, _preact.h)("span", {
          style: {
            display: 'flex',
            alignItems: 'center'
          },
          className: "main-menu-trigger"
        }, (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
          m: "Common",
          p: "main.navigation.menu_label"
        })), (0, _preact.h)(_ChevronDown.default, null))
      }, (0, _preact.h)("span", {
        className: "arrow is-hidden-S"
      }), (0, _preact.h)(_list.default, {
        className: "main-menu-list--overflow-scroll"
      }, (0, _preact.h)(_list.default, null, (0, _preact.h)(_link.default, {
        href: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.getSubfolderPrefix)(), "/"))
      }, (0, _preact.h)(_phrase.default, {
        m: "Common",
        p: "nav.title.forum.overview"
      })), (0, _preact.h)(_link.default, {
        href: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.getSubfolderPrefix)(), "/activity/recent"))
      }, (0, _preact.h)(_phrase.default, {
        m: "Common",
        p: "nav.title.forum.recent.activity"
      })), showActivitySinceLastVisit ? (0, _preact.h)(_link.default, {
        href: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.getSubfolderPrefix)(), "/activity/sincelastvisit"))
      }, (0, _preact.h)(_phrase.default, {
        m: "Common",
        p: "nav.title.forum.activity.last.visit"
      })) : null, (0, _preact.h)(_link.default, {
        href: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.getSubfolderPrefix)(), "/activity/unanswered"))
      }, (0, _preact.h)(_phrase.default, {
        m: "Common",
        p: "nav.title.forum.unanswered.questions"
      }))), knowledgeBaseCategories.length ? (0, _preact.h)("section", {
        className: "main-menu-section"
      }, (0, _preact.h)("div", {
        className: "main-menu-section__title"
      }, (0, _preact.h)(_phrase.default, {
        p: "nav.title.knowledgebase"
      })), knowledgeBaseCategories.map(function (parentCategory) {
        return (0, _preact.h)(_categoryGroup.default, {
          getItemProps: function getItemProps() {},
          key: parentCategory.id,
          url: parentCategory.url,
          title: parentCategory.title,
          categories: parentCategory.subforums
        });
      })) : null, communityCategories.length ? (0, _preact.h)("section", {
        className: "main-menu-section"
      }, (0, _preact.h)("div", {
        className: "main-menu-section__title"
      }, (0, _preact.h)(_phrase.default, {
        p: "nav.title.community"
      })), communityCategories.map(function (parentCategory) {
        return (0, _preact.h)(_categoryGroup.default, {
          key: parentCategory.id,
          url: parentCategory.url,
          title: parentCategory.title,
          categories: parentCategory.subforums
        });
      })) : null)));
    }
  }]);
  return MainMenu;
}(_preact.Component);

exports.default = MainMenu;